import {Input} from "antd";
import {useState} from "react";

export const SearchBar = ({onSearch}) => {
    const [query,setQuery] = useState('');

    const handleSearch = (value) => {
        onSearch(value);
    }
    return (
        <div className="w-full flex justify-center mb-2">
            <div className="lg:w-1/2 w-full flex items-center justify-center">
                <Input
                    placeholder="Tìm kiếm"
                    allowClear
                    rootClassName={"lg:w-1/2 flex-1 rounded-l-full"}
                    size="large"
                    onSearch={(e) => setQuery(e.target.value)}
                    />
                <button onClick={handleSearch} className={"bg-primary text-white rounded-r-full px-4 py-2"}>Tìm kiếm</button>
            </div>
        </div>
    )
}